export const PAGE_SIZES = [10, 15, 20, 30, 50, 100];
